import { render, staticRenderFns } from "./TheSourcePagination2.vue?vue&type=template&id=59f9b5dc&scoped=true&"
import script from "./TheSourcePagination2.vue?vue&type=script&lang=js&"
export * from "./TheSourcePagination2.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePagination2.vue?vue&type=style&index=0&id=59f9b5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f9b5dc",
  null
  
)

export default component.exports